import { useRive } from '@rive-app/react-canvas-lite';
import { useEffect, useState } from 'react';

interface AgentRiveAnimationProps {
  className?: string;
  isLoading?: boolean;
  size?: number;
}

const IDLE_ANIMATION = 'happy[static]';
const LOADING_ANIMATION = 'thinkingShort';

export default function AgentRiveAnimation({ className, isLoading = false, size = 24 }: AgentRiveAnimationProps) {
  const [hydrated, setHydrated] = useState(false);

  const { rive, RiveComponent } = useRive({
    src: '/public/animations/agent.riv',
    autoplay: true,
    animations: isLoading ? LOADING_ANIMATION : IDLE_ANIMATION,
  });

  // Don't render until after the react app mounts to avoid hydration mismatches
  useEffect(() => {
    setHydrated(true);
  }, []);

  useEffect(() => {
    if (!rive) return;
    const next = isLoading ? LOADING_ANIMATION : IDLE_ANIMATION;
    rive.stop();
    rive.play(next);
  }, [rive, isLoading]);

  if (!hydrated) return null;

  return (
    <div aria-hidden="true" className={className} style={{ width: size, height: size }}>
      <RiveComponent />
    </div>
  );
}
